import { SVGProps } from "react"
const Filter2Icon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.428 4.42969L7.28516 4.42969"
      stroke={props.color || "#2B3F6C"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="1.42857"
      cy="1.42857"
      r="1.42857"
      transform="matrix(-1 0 0 1 4.42773 3)"
      stroke={props.color || "#2B3F6C"}
      strokeWidth="1.5"
    />
    <path
      d="M1.57003 11.5742L8.71289 11.5742"
      stroke={props.color || "#2B3F6C"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="12.9989"
      cy="11.5731"
      r="1.42857"
      stroke={props.color || "#2B3F6C"}
      strokeWidth="1.5"
    />
  </svg>
)
export default Filter2Icon
